import React from "react"
import {
  Box,
  Container,
  Grid,
  Flex,
  Heading,
  Text,
} from "@theme-ui/components"
import { ArrowUpRight } from "react-feather"
import { Link } from "../link"
import { i18nContext } from "../../context/i18nContext"
import { LanguageSwitcherContext } from "../../context/languageSwitcherContext"
import { getPagePath, getStoryCategoryPath } from "../../utils/path"

const StoryCategoriesCollection = ({ title, description, categories }) => (
  <LanguageSwitcherContext.Consumer>
    {({ activeLocale }) => (
      <i18nContext.Consumer>
        {t => (
          <Container sx={{ py: [4, 5] }}>
            {title && (
              <Heading
                as="h2"
                variant="h2"
                dir="invalid"
                sx={{ color: "primary", mt: 0, mb: [3, 4] }}
              >
                {title}
              </Heading>
            )}
            {description && (
              <Box
                sx={{
                  color: "lightGrey",
                  mb: [4, 5],
                  "p:last-of-type": { mb: 0 },
                  "strong, b": { color: "secondary" },
                  img: { maxWidth: "100%", height: "auto" },
                }}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            <Grid columns={[2, 2, 3]} gap={[3, 4]}>
              {categories.map(category => (
                <CategoryCard
                  key={category.id}
                  category={category}
                  locale={activeLocale}
                  eyebrow={t.stories}
                />
              ))}
            </Grid>
          </Container>
        )}
      </i18nContext.Consumer>
    )}
  </LanguageSwitcherContext.Consumer>
)

const cardSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  bg: "lightBackground",
  border: "1px solid",
  borderColor: "primary",
  p: [3, 4],
  minHeight: ["12rem", "14rem", "16rem"],
  textDecoration: "none",
  "&, &:hover, &:focus": { textDecoration: "none" },
  transition: "transform 0.2s ease",
  "&:hover": { transform: "translateY(-2px)" },
}

const getCategoryHref = (category, locale) =>
  category.model && category.model.apiKey === "page"
    ? getPagePath(category, locale)
    : getStoryCategoryPath(category, locale)

const CategoryCard = ({ category, locale, eyebrow }) => (
  <Link to={getCategoryHref(category, locale)} sx={cardSx}>
    <Box>
      <Text
        variant="caption"
        sx={{
          display: "block",
          color: "primary",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          mb: [2, 3],
        }}
      >
        {eyebrow}
      </Text>
      <Heading
        as="h3"
        dir="invalid"
        sx={{
          color: "primary",
          mt: 0,
          mb: 0,
          fontFamily: "heading",
          fontWeight: "body",
          lineHeight: 1.1,
          fontSize: [3, 4, 5],
          hyphens: "auto",
          overflowWrap: "anywhere",
        }}
      >
        {category.title}
      </Heading>
    </Box>
    <Flex
      sx={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        bg: "primary",
        color: "light",
        alignItems: "center",
        justifyContent: "center",
        mt: [3, 4],
      }}
    >
      <ArrowUpRight size={20} />
    </Flex>
  </Link>
)

export default StoryCategoriesCollection
